import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  name: string;
  errorMessage?: string;
}

@Component({
  standalone: false,
  selector: 'app-add-fuel-type-dialog',
  templateUrl: 'add-fuel-type-dialog.component.html',
  styleUrls: ['add-fuel-type-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AddFuelTypeDialogComponent {
  errorMessage: string;

  constructor(
    public dialogRef: MatDialogRef<AddFuelTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.errorMessage = data.errorMessage || '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
